//components
import { PERMISSIONS, ROUTES } from 'consts'

//views
import Login from 'views/login'
import OrderList from 'views/order-list'
import OTP from 'views/otp'
import PasswordNew from 'views/password-new'
import ForgetPassword from 'views/forget-password'
import Promotion from 'views/promotion'
import PromotionForm from 'views/promotion/promotion-form'
import Branch from 'views/branch'
import Region from 'views/region'
import Tax from 'views/tax'
import Categories from 'views/categories'
import Category from 'views/category'
import Product from 'views/product'
import Employee from 'views/employee'
import Customer from 'views/customer'
import ProductForm from 'views/product/product-form'
import Topping from 'views/topping'
import Supplier from 'views/supplier'
import Country from 'views/country'
import Blog from 'views/blog'
import Role from 'views/role'
import Menu from 'views/menu'
import SetMenu from 'views/set-menu'
import SetMenuForm from 'views/set-menu/menu-form'
import MenuForm from 'views/menu/menu-form'
import BlogForm from 'views/blog/blog-form'
import Payment from 'views/payment'
import TableManager from 'views/table-manager'
import DataDeletionPolicy from 'views/data-deletion-policy'
import Souvenir from 'views/souvenir'
import Voucher from 'views/voucher'
import VoucherGift from 'views/voucher-gift'
import EmailManager from 'views/email-manager'
import ServiceFee from 'views/service-fee'
import Comment from 'views/comment'
import Review from 'views/review'
import GiftCard from 'views/giftcard'
import GiftCardForm from 'views/giftcard/giftcard-form'
import ProductType from 'views/product-type'
import BlockOrder from 'views/block-order'
import BookingStatistic from 'views/booking-statistic'
import Invitation from 'views/invitation'

export const DEFINE_ROUTER = [
  {
    path: ROUTES.BRANCH,
    Component: () => <Branch />,
    title: 'Quản lý chi nhánh',
    permissions: [PERMISSIONS.quan_ly_chi_nhanh],
    exact: true,
  },
  {
    path: ROUTES.BLOCK_ORDER,
    Component: () => <BlockOrder />,
    title: 'Quản lý block order',
    permissions: [PERMISSIONS.quan_ly_block_order],
    exact: true,
  },
   {
    path: ROUTES.BOOKING_STATISTIC,
    Component: () => <BookingStatistic />,
    title: 'Báo cáo booking',
    permissions: [PERMISSIONS.bao_cao_booking],
    exact: true,
  },
  {
    path: ROUTES.INVITATION,
    Component: () => <Invitation />,
    title: 'Quản lý invitation',
    permissions: [PERMISSIONS.quan_ly_invitation],
    exact: true,
  },
  {
    path: ROUTES.SERVICE_FEE,
    Component: () => <ServiceFee />,
    title: 'Quản lý phí dịch vụ',
    permissions: [PERMISSIONS.quan_ly_phi_dich_vu],
    exact: true,
  },
  {
    path: ROUTES.CUSTOMER,
    Component: () => <Customer />,
    title: 'Quản lý khách hàng',
    permissions: [PERMISSIONS.quan_ly_khach_hang],
    exact: true,
  },
  {
    path: ROUTES.EMAIL_MANAGER,
    Component: () => <EmailManager />,
    title: 'Cài đặt email quản lý',
    permissions: [PERMISSIONS.cai_dat_email_quan_ly],
    exact: true,
  },
  {
    path: ROUTES.ROLE,
    Component: () => <Role />,
    title: 'Quản lý phân quyền',
    permissions: [PERMISSIONS.quan_ly_phan_quyen],
    exact: true,
  },
  {
    path: ROUTES.MENU,
    Component: () => <Menu />,
    title: 'Quản lý thực đơn',
    permissions: [PERMISSIONS.quan_ly_thuc_don],
    exact: true,
  },
  {
    path: ROUTES.SETMENU,
    Component: () => <SetMenu />,
    title: 'Quản lý set menu',
    permissions: [PERMISSIONS.quan_ly_setmenu],
    exact: true,
  },
  {
    path: ROUTES.SETMENU_CREATE,
    Component: () => <SetMenuForm />,
    title: 'Tạo setmenu',
    permissions: [PERMISSIONS.quan_ly_setmenu],
  },
  {
    path: ROUTES.SETMENU_UPDATE,
    Component: () => <SetMenuForm />,
    title: 'Cập nhật setmenu',
    permissions: [PERMISSIONS.quan_ly_setmenu],
    exact: true,
  },
  {
    path: ROUTES.MENU_CREATE,
    Component: () => <MenuForm />,
    title: 'Tạo thực đơn',
    permissions: [PERMISSIONS.them_thuc_don],
    exact: true,
  },
  {
    path: ROUTES.REVIEW,
    Component: () => <Review />,
    title: 'Review',
    permissions: [],
    exact: true,
  },
  {
    path: ROUTES.MENU_UPDATE,
    Component: () => <MenuForm />,
    title: 'Cập nhật thực đơn',
    permissions: [PERMISSIONS.cap_nhat_thuc_don],
    exact: true,
  },
  {
    path: ROUTES.BLOG,
    Component: () => <Blog />,
    title: 'Quản lý bài viết',
    permissions: [PERMISSIONS.quan_ly_bai_viet],
    exact: true,
  },
  {
    path: ROUTES.BLOG_CREATE,
    Component: () => <BlogForm />,
    title: 'Tạo bài viết',
    permissions: [PERMISSIONS.them_bai_viet],
    exact: true,
  },
  {
    path: ROUTES.BLOG_UPDATE,
    Component: () => <BlogForm />,
    title: 'Cập nhật bài viết',
    permissions: [PERMISSIONS.cap_nhat_bai_viet],
    exact: true,
  },
  {
    path: ROUTES.COUNTRY,
    Component: () => <Country />,
    title: 'Quản lý quốc gia',
    permissions: [PERMISSIONS.quan_ly_quoc_gia],
    exact: true,
  },
  // {
  //   path: ROUTES.DOMAIN,
  //   Component: () => <Domain />,
  //   title: 'Quản lý tên miền',
  //   permissions: [PERMISSIONS.],
  //   exact: true,
  // },
  {
    path: ROUTES.REGION,
    Component: () => <Region />,
    title: 'Quản lý khu vực',
    permissions: [PERMISSIONS.quan_ly_khu_vuc],
    exact: true,
  },
  {
    path: ROUTES.TABLE,
    Component: () => <TableManager />,
    title: 'Quản lý đặt bàn',
    permissions: [PERMISSIONS.quan_ly_dat_ban],
    exact: true,
  },
  {
    path: ROUTES.SUPPLIER,
    Component: () => <Supplier />,
    title: 'Quản lý nhà cung cấp',
    permissions: [],
    exact: true,
  },
  {
    path: ROUTES.SOUVENIR,
    Component: () => <Souvenir />,
    title: 'Quản lý quà lưu niệm',
    permissions: [PERMISSIONS.quan_ly_qua_luu_niem],
    exact: true,
  },
  {
    path: ROUTES.SOUVENIR_ADD,
    Component: () => <ProductForm />,
    title: 'Thêm món ăn',
    permissions: [PERMISSIONS.them_mon_an],
    exact: true,
  },
  {
    path: ROUTES.SOUVENIR_UPDATE,
    Component: () => <ProductForm />,
    title: 'Cập nhật món ăn',
    permissions: [PERMISSIONS.cap_nhat_mon_an],
    exact: true,
  },
  {
    path: ROUTES.PROMOTION,
    Component: () => <Promotion />,
    title: 'Chương trình khuyến mãi',
    permissions: [PERMISSIONS.chuong_trinh_khuyen_mai],
    exact: true,
  },
  {
    path: ROUTES.PROMOTION_CREATE,
    Component: () => <PromotionForm />,
    title: 'Tạo chương trình khuyến mãi',
    permissions: [PERMISSIONS.them_chuong_trinh_khuyen_mai],
    exact: true,
  },
  {
    path: ROUTES.PROMOTION_UPDATE,
    Component: () => <PromotionForm />,
    title: 'Cập nhật chương trình khuyến mãi',
    permissions: [PERMISSIONS.cap_nhat_chuong_trinh_khuyen_mai],
    exact: true,
  },
  {
    path: ROUTES.GIFTCARD,
    Component: () => <GiftCard />,
    title: 'GiftCard',
    permissions: [],
    exact: true,
  },
  {
    path: ROUTES.GIFTCARD_FROM,
    Component: () => <GiftCardForm />,
    title: 'GiftCard Form',
    permissions: [],
    exact: true,
  },
  {
    path: ROUTES.VOUCHER,
    Component: () => <Voucher />,
    title: 'Voucher mua',
    permissions: [PERMISSIONS.quan_ly_voucher_da_mua],
    exact: true,
  },
  {
    path: ROUTES.VOUCHER_GIFT,
    Component: () => <VoucherGift />,
    title: 'Voucher tặng',
    permissions: [PERMISSIONS.quan_ly_voucher_da_tang],
    exact: true,
  },
  {
    path: ROUTES.TAX,
    Component: () => <Tax />,
    title: 'Quản lý thuế',
    permissions: [PERMISSIONS.quan_ly_thue],
    exact: true,
  },
  {
    path: ROUTES.PAYMENT,
    Component: () => <Payment />,
    title: 'Quản lý hình thức thanh toán',
    permissions: [PERMISSIONS.phuong_thuc_thanh_toan],
    exact: true,
  },
  {
    path: ROUTES.ORDER_LIST,
    Component: () => <OrderList />,
    title: 'Danh sách đơn hàng',
    permissions: [PERMISSIONS.don_hang],
    exact: true,
  },
  {
    path: ROUTES.PRODUCT,
    Component: () => <Product />,
    title: 'Quản lý món ăn',
    permissions: [PERMISSIONS.quan_ly_mon_an],
    exact: true,
  },
  {
    path: ROUTES.PRODUCT_ADD,
    Component: () => <ProductForm />,
    title: 'Thêm món ăn',
    permissions: [PERMISSIONS.them_mon_an],
    exact: true,
  },
  {
    path: ROUTES.PRODUCT_UPDATE,
    Component: () => <ProductForm />,
    title: 'Cập nhật món ăn',
    permissions: [PERMISSIONS.cap_nhat_mon_an],
  },
  {
    path: ROUTES.PRODUCT_TYPE,
    Component: () => <ProductType />,
    title: 'Cách nấu',
    permissions: [PERMISSIONS.topping],
    exact: true,
  },
  {
    path: ROUTES.TOPPING,
    Component: () => <Topping />,
    title: 'Topping',
    permissions: [PERMISSIONS.topping],
    exact: true,
  },
  {
    path: ROUTES.EMPLOYEE,
    Component: () => <Employee />,
    title: 'Quản lý nhân sự',
    permissions: [PERMISSIONS.quan_ly_nhan_vien],
    exact: true,
  },
  {
    path: ROUTES.CATEGORIES,
    Component: () => <Categories />,
    title: 'Quản lý phân loại món',
    permissions: [PERMISSIONS.phan_loai_mon],
    exact: true,
  },
  {
    path: ROUTES.CATEGORY,
    Component: () => <Category />,
    title: 'Phân loại món',
    permissions: [PERMISSIONS.phan_loai_mon],
    exact: true,
  },
  {
    path: ROUTES.COMMENT,
    Component: () => <Comment />,
    title: 'Quản lý nhận xét',
    permissions: [PERMISSIONS.quan_ly_nhan_xet],
    exact: true,
  },
  {
    path: ROUTES.PRODUCT_TYPE,
    Component: () => <ProductType />,
    title: 'Cách nấu',
    permissions: [],
    exact: true,
  },
]

export const AUTH_ROUTER = [
  {
    path: ROUTES.OTP,
    Component: () => <OTP />,
    exact: true,
    title: 'OTP',
    permissions: [],
  },
  {
    path: ROUTES.PASSWORD_NEW,
    Component: () => <PasswordNew />,
    exact: true,
    title: 'New password',
    permissions: [],
  },
  {
    path: ROUTES.FORGET_PASSWORD,
    Component: () => <ForgetPassword />,
    exact: true,
    title: 'Forget password',
    permissions: [],
  },
  {
    path: ROUTES.LOGIN,
    Component: () => <Login />,
    exact: true,
    title: 'Login',
    permissions: [],
  },
  {
    path: ROUTES.DATA_DELETION_POLICY,
    Component: () => <DataDeletionPolicy />,
    title: 'Chính sách xóa dữ liệu',
    permissions: [],
    exact: true,
  },
]
